export var HTTP;
(function (HTTP) {
    HTTP["DELETE"] = "DELETE";
    HTTP["GET"] = "GET";
    HTTP["OPTIONS"] = "OPTIONS";
    HTTP["PATCH"] = "PATCH";
    HTTP["POST"] = "POST";
    HTTP["PUT"] = "PUT";
})(HTTP || (HTTP = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLElBT1g7QUFQRCxXQUFZLElBQUk7SUFDZCx5QkFBaUIsQ0FBQTtJQUNqQixtQkFBVyxDQUFBO0lBQ1gsMkJBQW1CLENBQUE7SUFDbkIsdUJBQWUsQ0FBQTtJQUNmLHFCQUFhLENBQUE7SUFDYixtQkFBVyxDQUFBO0FBQ2IsQ0FBQyxFQVBXLElBQUksS0FBSixJQUFJLFFBT2YiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBIVFRQIHtcbiAgREVMRVRFID0gJ0RFTEVURScsXG4gIEdFVCA9ICdHRVQnLFxuICBPUFRJT05TID0gJ09QVElPTlMnLFxuICBQQVRDSCA9ICdQQVRDSCcsXG4gIFBPU1QgPSAnUE9TVCcsXG4gIFBVVCA9ICdQVVQnLFxufVxuIl19